import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { HeaderComponent } from '../../shared/header/header.component';
import { CashRegisterService } from '../../../services/cash-register/cash-register.service';
import { PaymentService } from '../../../services/payment/payment.service';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';

@Component({
  selector: 'app-lancamentos-financeiros',
  standalone: true,
  imports: [CommonModule, HeaderComponent, RouterLink],
  templateUrl: './lancamentos-financeiros.component.html',
})
export class LancamentosFinanceirosComponent implements OnInit {
  isSupervisor = false;
  hasCaixaAccess = false;
  avulsoLiberado = false;

  constructor(
    private router: Router,
    private cashRegisterService: CashRegisterService,
    private paymentService: PaymentService,
    private localStorage: LocalStorageService,
  ) {}

  async ngOnInit() {
    const username = this.localStorage.get('login') as string;
    if (!username) return;

    const unidade = Number(this.localStorage.get('currentUnit'));
    const caixas = await this.cashRegisterService.getByUnit(unidade, username);
    this.hasCaixaAccess = caixas.length > 0;
    this.avulsoLiberado = await this.paymentService.getPagamentoAvulsoLiberado(unidade);

    const profileLocal = this.localStorage.get('profile') as string | null;
    if (profileLocal === 'Administrador') {
      this.isSupervisor = true;
      return;
    }
    const perfil = await this.cashRegisterService.getUserProfile(username);
    this.isSupervisor = !!(perfil?.isSupervisorGlobal || perfil?.isSupervisorUnit);
  }

  abrirSangria() {
    this.router.navigate(['/lancamentos-financeiros/sangria']);
  }

  abrirPagamentoAvulso() {
    this.router.navigate(['/lancamentos-financeiros/pagamento-avulso']);
  }

  abrirEstacionamento() {
    this.router.navigate(['/lancamentos-financeiros/estacionamento']);
  }

  abrirHistorico() {
    this.router.navigate(['/lancamentos-financeiros/historico']);
  }

  abrirAnaliseCaixas() {
    this.router.navigate(['/lancamentos-financeiros/analise-caixas']);
  }

  abrirAnalisePendencias() {
    this.router.navigate(['/lancamentos-financeiros/analise-pendencias']);
  }
}
